export default __webpack_public_path__ + "static/media/tw.0e99b0ca.svg";